import React, { useEffect, useState } from 'react';
import { Box } from '@chakra-ui/react';
import LocationTable from './components/RoleTable';
import RoleTable from './components/RoleTable';
import toast from 'react-hot-toast';
import { createAPIEndPoint } from 'config/api/api';
import Loader from 'loaders/Loader';
import { logoutUser } from 'utils';
import { useNavigate } from 'react-router-dom';
import { getUserData } from 'utils';

const Role = () => {
  const navigate = useNavigate();
  const userData = getUserData();
  const clinic_id = userData?.clinic_id ?? null;
  const [rolesData, setRolesData] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchRoles = async () => {
    setLoading(true);
    try {
      const response = await createAPIEndPoint(
        `clinic_roles/get_all/${clinic_id}`,
      ).fetchAll();
      setRolesData(response.data.roles || []);
    } catch (err) {
      toast.error(err?.response?.data?.error || 'Error fetching clinic roles');
      if (err?.response?.data?.error?.includes('Bearer token')) {
        logoutUser(navigate);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRoles();
  }, []);

  return (
    <Box pt={{ base: '80px', md: '80px', xl: '80px' }}>
      {loading && <Loader />}
      <RoleTable
        tableData={rolesData}
        loading={loading}
        fetchAgain={fetchRoles}
      />{' '}
    </Box>
  );
};

export default Role;
